import { memo } from "react";
import Layout from "./Layout";

const LoadingElementPost = memo(() => (
  <li className="animate-pulse list-none py-6">
    <div className="flex animate-pulse space-x-4">
      <div className="flex-1 space-y-6 py-1">
        <div className="h-2 max-w-sm rounded bg-slate-200"></div>
        <div className="space-y-3">
          <div className="grid grid-cols-3 gap-4">
            <div className="col-span-2 h-2 rounded bg-slate-200"></div>
            <div className="col-span-1 h-2 rounded bg-slate-200"></div>
          </div>
          <div className="h-2 rounded bg-slate-200"></div>
        </div>
      </div>
    </div>
  </li>
));

LoadingElementPost.displayName = "LoadingElementPost";

const LoadingPost: React.FC = () => (
  <Layout>
    <main>
      <div className=" ml-auto mr-auto max-w-section px-4">
        <div className="s mx-auto mb-10 rounded-3xl px-4 py-8 md:px-10">
          <ul>
            <LoadingElementPost />
            <LoadingElementPost />
            <LoadingElementPost />
            <LoadingElementPost />
            <LoadingElementPost />
            <LoadingElementPost />
            <LoadingElementPost />
            <LoadingElementPost />
          </ul>
        </div>
      </div>
    </main>
  </Layout>
);

export default LoadingPost;
